import { useCurrentUser } from '@/services/auth';

import { useImplantQueueFieldOptions } from '../ImplantQueueTab/fieldOptions';

export const useCheckedByOptions = () => {
  const { data: currentUser } = useCurrentUser();
  const { techOptions } = useImplantQueueFieldOptions();
  const userName = currentUser?.displayName?.trim().toLowerCase();
  const defaultCheckedById =
    (userName &&
      techOptions.find(
        (option) => option.label.trim().toLowerCase() === userName,
      )?.value) ||
    '';

  return { techOptions, defaultCheckedById };
};
